import { Meeting, MeetingSession } from "@kalyzee/kast-websocket-module";
import { useAppSelector } from "../../hooks/app";
import selectMeeting from "./selectors";

export const useMeeting = (): Meeting | undefined => useAppSelector(selectMeeting.meeting);
export const useMeetingId = (): string | undefined => useAppSelector(selectMeeting.meetingId);
export const useMeetingSession = (): MeetingSession | undefined => useAppSelector(selectMeeting.session);
export const useMeetingMediaDestinations = (): {[id: string]: string} => useAppSelector(selectMeeting.mediaDestinations);